import React, { useState, useEffect, useRef } from 'react';

export default function CorcheaAnimation({ amount, triggerKey }) {
  const [particles, setParticles] = useState([]);
  const prevKey = useRef(null);

  useEffect(() => {
    if (!triggerKey || triggerKey === prevKey.current || !amount) return;
    prevKey.current = triggerKey;

    const count = Math.min(8, Math.max(4, Math.abs(amount)));
    const newParticles = Array.from({ length: count }, (_, i) => ({
      id: `${triggerKey}-${i}`,
      offsetX: (Math.random() - 0.5) * 80,
      duration: 1.0 + Math.random() * 0.8,
      delay: i * 0.08,
      size: 13 + Math.random() * 5,
    }));

    setParticles(newParticles);
    const timer = setTimeout(() => setParticles([]), 2500);
    return () => clearTimeout(timer);
  }, [triggerKey, amount]);

  if (!particles.length) return null;

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden z-50">
      {particles.map(p => (
        <div
          key={p.id}
          className="absolute left-1/2 bottom-1/3"
          style={{
            transform: `translateX(${p.offsetX}px)`,
            animation: `corcheaFloat ${p.duration}s ease-out ${p.delay}s both`,
            fontSize: p.size,
            fontWeight: 700,
            color: '#F5C842',
            textShadow: '0 0 12px rgba(245,200,66,0.6)',
          }}
        >
          +{amount} <span style={{ fontSize: p.size * 0.8 }}>&#9835;</span>
        </div>
      ))}
    </div>
  );
}
